import { createSlice } from '@reduxjs/toolkit';
import { fetcherPost, fetcherGet  } from "../utils/fetcher";
import { setLoader } from './commonSlice';
import { APIS, isEmpty } from '../utils/constants';
// import { checkNextPage } from '../utils/logger';

const initialState = {
   creditList: [],
   creditRequestDetails: []
}

const creditSlice = createSlice({
    name: 'task',
    initialState,
    reducers: {
        setCreditList: (state, action) => {
            state.creditList = action.payload
        },
        setCreditRequestDetails:(state, action) => {
            state.creditRequestDetails = action.payload
        }
    },
});




export function getCreditListData(limit = 50, page = 1) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS.GET_CREDIT_REQUESTS}?limit=${limit}&page=${page}`)
            .then((response) => {
                const allCreditList = !isEmpty(response?.data) ? response?.data : [];
                dispatch(setCreditList(allCreditList));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getCreditRequestDetails(id) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS.GET_CREDIT_REQUESTS_DETAILS}?request_id=${id}`)
            .then((response) => {
                const allCreditList = !isEmpty(response?.data) ? response?.data : [];
                dispatch(setCreditRequestDetails(allCreditList));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getCreditList(page = 1, searchQuery, limit=10) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_CREDIT_REQUESTS}?page=${page}`;
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}&limit=${limit}`
        }
        fetcherGet(url)
            .then((response) => {
                dispatch(setCreditList(!isEmpty(response?.data) ? response?.data : []));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

// To POST CREDIT REQUEST
export function postCreditRequest(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.POST_CREDIT_REQUEST, payload)
            .then((res) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(res?.data);
                }
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}


export const { setCreditList, setCreditRequestDetails} = creditSlice.actions;

export default creditSlice.reducer;